export default __webpack_public_path__ + "static/media/423.23d6f610.png";